/**
 * Interceptor để che giấu Firebase API calls
 * Redirect tất cả Firebase API calls qua server
 * 
 * CRITICAL: File này PHẢI được import TRƯỚC Firebase SDK
 */

// Import config để lấy API_BASE_URL
let API_BASE_URL = '';
try {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host && host !== 'localhost' && host !== '127.0.0.1') {
    API_BASE_URL = '';
  } else if (typeof window !== 'undefined' && window.REACT_APP_API_URL) {
    API_BASE_URL = window.REACT_APP_API_URL;
  } else {
    const config = require('../config');
    API_BASE_URL = config.API_BASE_URL || 'http://localhost:5002';
  }
} catch (e) {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  API_BASE_URL = (host === 'localhost' || host === '127.0.0.1')
    ? 'http://localhost:5002'
    : '';
}

console.log('[Firebase Interceptor] Initialized. API_BASE_URL:', API_BASE_URL);

// Intercept fetch requests - MUST be done before Firebase SDK loads
const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    
    // Check for Firebase/Google Identity Toolkit API calls
    // Check cả identitytoolkit.googleapis.com và googleapis.com/identitytoolkit
    if (typeof url === 'string' && 
        (url.includes('identitytoolkit.googleapis.com') || 
         url.includes('googleapis.com/identitytoolkit') ||
         (url.includes('googleapis.com') && url.includes('identitytoolkit')) ||
         (url.includes('googleapis.com') && url.includes('projects?key=')))) {
    try {
      const urlObj = new URL(url);
      const apiKey = urlObj.searchParams.get('key');
      
      if (apiKey) {
        // Block projects endpoint (lộ API key) - Check FIRST
        if (url.includes('/v1/projects') || url.includes('/projects?key=') || url.includes('projects?key=')) {
          console.warn('[Firebase Interceptor] Blocked /projects:', url);
          return originalFetch(`${API_BASE_URL}/api/auth/projects`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              ...(args[1]?.headers || {})
            }
          });
        }
        
        // Block getProjectConfig endpoint (lộ API key)
        if (url.includes('getProjectConfig') || url.includes('/v3/relyingparty/getProjectConfig')) {
          console.warn('[Firebase Interceptor] Blocked getProjectConfig:', url);
          return originalFetch(`${API_BASE_URL}/api/auth/project-config`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              ...(args[1]?.headers || {})
            }
          });
        }
        
        // Block accounts:lookup (lộ API key)
        if (url.includes('accounts:lookup')) {
          console.warn('[Firebase Interceptor] Blocked accounts:lookup:', url);
          const body = args[1]?.body;
          let emailMatch = null;
          
          try {
            if (body) {
              emailMatch = typeof body === 'string' ? JSON.parse(body) : body;
            }
          } catch (e) {
            // Ignore parse errors
          }
          
          if (emailMatch && emailMatch.email) {
            // Redirect qua server API
            const email = Array.isArray(emailMatch.email) ? emailMatch.email[0] : emailMatch.email;
            console.log('[Firebase Interceptor] Redirecting to server:', email);
            
            return originalFetch(`${API_BASE_URL}/api/auth/lookup`, {
              method: 'POST',
              body: JSON.stringify({ email }),
              headers: {
                'Content-Type': 'application/json',
                ...(args[1]?.headers || {})
              }
            }).then(response => {
              // Transform response để match Firebase format
              return response.json().then(data => {
                return new Response(JSON.stringify({
                  users: data.users || []
                }), {
                  status: response.status,
                  statusText: response.statusText,
                  headers: response.headers
                });
              });
            }).catch(error => {
              console.error('[Firebase Interceptor] Error:', error);
              // Return empty response if server fails
              return new Response(JSON.stringify({ users: [] }), {
                status: 200,
                headers: { 'Content-Type': 'application/json' }
              });
            });
          }
        }
        
        // Cho phép các API khác đi qua (signInWithPassword, signUp, token refresh, Google Sign-In, etc.)
      }
    } catch (e) {
      // Nếu không parse được URL, tiếp tục bình thường
      console.warn('[Firebase Interceptor] Error parsing URL:', e);
    }
  }
  
  // Gọi original fetch cho các requests khác
  return originalFetch.apply(this, args);
};

// Intercept XMLHttpRequest
const originalXHROpen = XMLHttpRequest.prototype.open;
const originalXHRSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function(method, url, ...rest) {
  this._url = url;
  return originalXHROpen.apply(this, [method, url, ...rest]);
};

XMLHttpRequest.prototype.send = function(...args) {
  const url = this._url;
  
  // Nếu là Firebase API call với API key trong URL
  if (url && url.includes('identitytoolkit.googleapis.com')) {
    try {
      const urlObj = new URL(url);
      const apiKey = urlObj.searchParams.get('key');
      
      // CHỈ block accounts:lookup, cho phép các API khác đi qua
      if (apiKey && url.includes('accounts:lookup')) {
        console.warn('[Firebase Interceptor XHR] Blocked accounts:lookup:', url);
        
        // Redirect qua server API
        const body = args[0];
        let email = null;
        
        try {
          if (body) {
            const parsed = typeof body === 'string' ? JSON.parse(body) : body;
            if (parsed.email) {
              email = Array.isArray(parsed.email) ? parsed.email[0] : parsed.email;
            }
          }
        } catch (e) {
          // Ignore parse errors
        }
        
        if (email) {
          console.log('[Firebase Interceptor XHR] Redirecting to server:', email);
          
          // Override send để gọi server API
          const xhr = this;
          fetch(`${API_BASE_URL}/api/auth/lookup`, {
            method: 'POST',
            body: JSON.stringify({ email }),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => response.json())
            .then(data => {
              // Transform response để match Firebase format
              const firebaseResponse = {
                users: data.users || []
              };
              
              // Simulate XHR response
              Object.defineProperty(xhr, 'status', { value: 200, writable: false });
              Object.defineProperty(xhr, 'statusText', { value: 'OK', writable: false });
              Object.defineProperty(xhr, 'responseText', { value: JSON.stringify(firebaseResponse), writable: false });
              Object.defineProperty(xhr, 'readyState', { value: 4, writable: false });
              
              // Trigger events
              if (xhr.onload) xhr.onload();
              if (xhr.onreadystatechange) xhr.onreadystatechange();
            })
            .catch(error => {
              console.error('[Firebase Interceptor XHR] Error:', error);
              // Return empty response if server fails
              Object.defineProperty(xhr, 'status', { value: 200, writable: false });
              Object.defineProperty(xhr, 'statusText', { value: 'OK', writable: false });
              Object.defineProperty(xhr, 'responseText', { value: JSON.stringify({ users: [] }), writable: false });
              Object.defineProperty(xhr, 'readyState', { value: 4, writable: false });
              
              if (xhr.onload) xhr.onload();
              if (xhr.onreadystatechange) xhr.onreadystatechange();
            });
          
          return; // Don't call original send
        }
      }
      // Cho phép các API khác đi qua (không phải accounts:lookup)
    } catch (e) {
      // Nếu không parse được URL, tiếp tục bình thường
      console.warn('[Firebase Interceptor XHR] Error parsing URL:', e);
    }
  }
  
  // Gọi original send cho các requests khác
  return originalXHRSend.apply(this, args);
};

export default {};

